import { jsx as t } from "react/jsx-runtime";
import { useState as i, useEffect as b, useCallback as v } from "react";
import x from "./index.es766.js";
import { Dropdown as I } from "./index.es66.js";
import { MultiSelectDropdownMenu as L } from "./index.es71.js";
import { SelectBox as _ } from "./index.es38.js";
const g = "multi-select", k = ({
  items: o,
  onSelection: a,
  onItemSelection: r,
  align: m = "start",
  side: f = "bottom",
  testId: p = g,
  disabled: n,
  appendToParent: u,
  parentElement: h,
  CTA: S,
  withInlineSearch: T,
  ...E
}) => {
  const [c, s] = i(o), [d, l] = i("");
  b(() => {
    s(o);
  }, [o]);
  const D = c.filter(({ isSelected: e }) => e).map((e) => e.label).join(","), M = v(
    (e) => {
      r == null || r(e), l("");
    },
    [r]
  );
  return /* @__PURE__ */ t("div", { className: x.container, children: /* @__PURE__ */ t(
    I,
    {
      CTA: S,
      trigger: /* @__PURE__ */ t(_, { value: D, disabled: n, ...E }),
      align: m,
      side: f,
      closeOnSelection: !1,
      testId: p,
      disabled: n,
      appendToParent: u,
      parentElement: h,
      onInlineSearch: T ? l : void 0,
      scaleToAnchor: !0,
      children: /* @__PURE__ */ t(
        L,
        {
          items: c,
          onSelection: a ?? s,
          onItemSelection: M,
          searchTerm: d
        }
      )
    }
  ) });
};
export {
  g as MULTI_SELECT_DEFAULT_TESTID,
  k as MultiSelect
};
//# sourceMappingURL=index.es110.js.map
